var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "vue", "noty", "../Shared/KendoDataExtracter", "./BasicViewControllerWithCRUDDataSource", "../../html-templates/media-overlay-standalone-vue-template.html"], function (require, exports, vue_1, Noty, KendoDataExtracter_1, BasicViewControllerWithCRUDDataSource_1, template) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContentSelectionControllerEventTypes = (function () {
        function ContentSelectionControllerEventTypes() {
        }
        ContentSelectionControllerEventTypes.contentSelected = "contentSelected";
        ContentSelectionControllerEventTypes.dialogBeforeOpen = "dialogBeforeOpen";
        ContentSelectionControllerEventTypes.dialogClosed = "dialogClosed";
        return ContentSelectionControllerEventTypes;
    }());
    exports.ContentSelectionControllerEventTypes = ContentSelectionControllerEventTypes;
    var ContentSelectionController = (function (_super) {
        __extends(ContentSelectionController, _super);
        function ContentSelectionController(optionsParam) {
            if (optionsParam === void 0) { optionsParam = {}; }
            var _this = this;
            var defaultOPtions = {
                type: "Content",
                readApiUrl: "/api/v1/contents/overview",
                readApiDetailUrlPrefix: "/api/v1/contents/",
                IsInEditMode: undefined,
                htmlElementSelector: undefined,
                id: undefined,
                createApiUrl: undefined,
                updateApiUrl: undefined,
                destroyApiUrl: undefined,
                ignoreTypeArray: undefined,
                ignoreIdArray: undefined
            };
            var options_ = {};
            for (var key in optionsParam)
                defaultOPtions[key] = optionsParam[key];
            for (var key in defaultOPtions)
                options_[key] = defaultOPtions[key];
            _this = _super.call(this, options_) || this;
            if (_this.options["getUrlSuffix"] !== undefined)
                _this.options.readApiUrl += _this.options["getUrlSuffix"];
            return _this;
        }
        Object.defineProperty(ContentSelectionController.prototype, "vueRootElementTemplate", {
            get: function () { return "<div id=\"" + this.vueRootElementId + "\"></div>"; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ContentSelectionController.prototype, "vueContentTemplate", {
            get: function () { return template; },
            enumerable: true,
            configurable: true
        });
        ContentSelectionController.prototype.initVue = function () {
            var _this = this;
            this.vueRootElementId = 'div' + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
            this.dialog = $.dialog({
                title: '',
                content: this.vueRootElementTemplate,
                animation: 'zoom',
                columnClass: 'large',
                closeAnimation: 'scale',
                backgroundDismiss: true,
                closeIcon: true,
                draggable: false,
                onOpenBefore: function () { return _this.onDialogReady(); },
                onClose: function () { return _this.onDialogClose(); },
                onDestroy: function () { return _this.onDialogDestroy(); }
            });
        };
        ContentSelectionController.prototype.onDialogReady = function () {
            var _this = this;
            this.vueRoot = new vue_1.default({
                el: '#' + this.vueRootElementId,
                template: this.vueContentTemplate,
                data: {
                    model: [],
                    textSearchValue: '',
                    typeFilterValue: '',
                    sortByValue: 'date'
                },
                components: {},
                directives: {
                    focus: {
                        inserted: function (el) {
                            el.focus();
                        }
                    }
                },
                methods: {
                    showItem: function (item) {
                        return _this.filterItem(item);
                    },
                    getDistinctTypes: function () {
                        return window.Enumerable.from(this.model)
                            .where(function (item) { return item.AssetType || item.Type; })
                            .select(function (item) { return item.AssetType || item.Type; })
                            .distinct()
                            .toArray();
                    },
                    filterByType: function (e) {
                        console.log(e);
                        _this.vueRoot.typeFilterValue = $(e.currentTarget).val();
                    },
                    filterByText: function (e) {
                        console.log(e);
                    },
                    sortBy: function (e) {
                        console.log(e);
                        if (e != undefined && e.currentTarget != undefined)
                            _this.vueRoot.sortByValue = $(e.currentTarget).val();
                        switch (_this.vueRoot.sortByValue) {
                            case 'date':
                                _this.vueRoot.model = window.Enumerable.from(_this.vueRoot.model)
                                    .select(function (item) { return item; })
                                    .orderByDescending(function (item) {
                                    return item.CreatedAt;
                                })
                                    .toArray();
                                break;
                            case 'type':
                                _this.vueRoot.model = window.Enumerable.from(_this.vueRoot.model)
                                    .select(function (item) { return item; })
                                    .orderBy(function (item) {
                                    return item.AssetType || item.Type;
                                })
                                    .toArray();
                                break;
                        }
                    },
                    DsGetNewInstanceOfType: function (type) {
                        return _this.GetNewInstanceOfType(type);
                    },
                    GetData: function () {
                        console.log("getdata");
                        _this.options = window.optionslist;
                    },
                    onItemClick: function (item) { return _this.onItemClick(item); }
                }
            });
            window.initSelects();
            $('form.listing-travel-filter__form').on("submit", function (e) {
                e.preventDefault();
            });
            $('select.typeFilterField').on("change", function (e) {
                _this.vueRoot.filterByType(e);
            });
            $('select.sortField').on("change", function (e) {
                _this.vueRoot.sortBy(e);
            });
            this.FireEvent(ContentSelectionControllerEventTypes.dialogBeforeOpen);
        };
        ContentSelectionController.prototype.filterItem = function (item) {
            var textSearchValue = this.vueRoot.textSearchValue.trim();
            var typeFilterValue = this.vueRoot.typeFilterValue.trim();
            if (textSearchValue == '' && typeFilterValue == '')
                return true;
            else {
                var typeOk = true;
                var textOk = true;
                if (textSearchValue != '' || typeFilterValue != '') {
                    if (typeFilterValue != '') {
                        if (item.Type === typeFilterValue || (item.AssetType && item.AssetType === typeFilterValue))
                            typeOk = true;
                        else
                            typeOk = false;
                    }
                    if (textSearchValue != '') {
                        var itemText = item.Comment ? item.Comment.trim().toLowerCase() : "" + " " + item.Name ? item.Name.trim().toLowerCase() : "";
                        if (item.Type == "asset") {
                        }
                        var type = item.AssetType || item.Type;
                        var typeTranslate = "";
                        switch (type) {
                            case "scheduler":
                                typeTranslate = "Plan";
                                break;
                            case "sujet":
                                typeTranslate = "Sujet";
                                break;
                            case "playlist":
                                typeTranslate = "Playlist";
                                break;
                            case "video":
                                typeTranslate = "Video";
                                break;
                            case "image":
                                typeTranslate = "Image";
                                break;
                            case "stream":
                                typeTranslate = "Stream";
                                break;
                            case "website":
                                typeTranslate = "Website";
                                break;
                            case "freetext":
                                typeTranslate = "Free Text";
                                break;
                            case "multiscreen":
                                typeTranslate = "Layout";
                                break;
                        }
                        itemText += " " + type;
                        itemText += " " + typeTranslate.toLocaleLowerCase();
                        if (this.multiSearchAnd(itemText, textSearchValue.toLowerCase().split(" ")))
                            textOk = true;
                        else
                            textOk = false;
                    }
                    if (typeOk && textOk)
                        return true;
                    else
                        return false;
                }
            }
            return true;
        };
        ContentSelectionController.prototype.multiSearchAnd = function (text, searchWords) {
            var currTest;
            while (currTest = searchWords.pop()) {
                if (!text.match(new RegExp(currTest, "i")))
                    return false;
            }
            return true;
        };
        ContentSelectionController.prototype.onItemClick = function (item) {
            var _this = this;
            if (item.HasMetaData == false)
                return false;
            this.dialog.showLoading();
            jQuery.get(this.options.readApiDetailUrlPrefix + item.Id).then(function (response) {
                try {
                    _this.FireEvent(ContentSelectionControllerEventTypes.contentSelected, response);
                    _this.dialog.close();
                }
                catch (e) {
                    console.log("error @ ContentSelectionController.onItemClick: ", e);
                    new Noty({
                        text: "Bei der Auswahl des Elements ist ein Fehler aufgetreten. Versuchen Sie es erneut, oder wählen Sie ein anderes Element aus.",
                        type: 'error',
                        theme: 'metroui',
                        timeout: 6000
                    }).show();
                }
            }, function (response) {
                new Noty({
                    text: "Der Befehl konnte leider nicht ausgeführt werden.",
                    type: 'error',
                    theme: 'metroui',
                    timeout: 6000
                }).show();
            }).always(function () {
                _this.dialog.hideLoading();
            });
        };
        ContentSelectionController.prototype.onDialogClose = function () {
            this.FireEvent(ContentSelectionControllerEventTypes.dialogClosed);
        };
        ContentSelectionController.prototype.onDialogDestroy = function () {
        };
        ContentSelectionController.prototype.initRemoteDatasource = function () {
            var _this = this;
            this.AddEventListener(ContentSelectionControllerEventTypes.dialogBeforeOpen, function () {
                _this.remoteDataSource = new kendo.data.DataSource({
                    transport: {
                        read: {
                            url: _this.options.readApiUrl,
                            type: "get", dataType: "json", contentType: "application/json"
                        },
                        parameterMap: function (data, operation) {
                            if (operation !== "read" && data) {
                                return kendo.stringify(data);
                            }
                        }
                    },
                    schema: {
                        type: "json",
                        model: {
                            id: "Id",
                            fields: { Id: "Id" }
                        }
                    },
                    change: function (e) {
                        _this.vueRoot.model = [];
                        var result = e.items;
                        if (_this.options.ignoreTypeArray !== undefined && _this.options.ignoreTypeArray.length !== undefined && _this.options.ignoreTypeArray.length > 0) {
                            result = window.Enumerable.from(result)
                                .where(function (item) { return _this.options.ignoreTypeArray.indexOf(item.Type) == -1; })
                                .select(function (item) { return item; })
                                .toArray();
                        }
                        if (_this.options.ignoreIdArray !== undefined && _this.options.ignoreIdArray.length !== undefined && _this.options.ignoreIdArray.length > 0) {
                            result = window.Enumerable.from(result)
                                .where(function (item) { return _this.options.ignoreIdArray.indexOf(item.Id) == -1; })
                                .select(function (item) { return item; })
                                .toArray();
                        }
                        for (var i = 0; i < result.length; i++)
                            _this.vueRoot.model.push(KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(result[i]));
                        _this.vueRoot.sortBy();
                    },
                    requestEnd: function (e) {
                        _this.DSReqestEndHandler(e);
                        _this.dialog.hideLoading();
                    },
                    requestStart: function (e) {
                        _this.dialog.showLoading();
                    },
                    error: function (e) { return _this.DSErrorHandler(e); }
                });
                _this.remoteDataSource.fetch(function () {
                    console.log(_this.remoteDataSource.hasChanges());
                });
            });
        };
        return ContentSelectionController;
    }(BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource));
    exports.ContentSelectionController = ContentSelectionController;
    window["contenSelectorClass"] = ContentSelectionController;
});
//# sourceMappingURL=ContentSelectionController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/ContentSelectionController.js
// module id = 110
// module chunks = 0